import { render } from "./usa.svg?vue&type=template&id=437e3620"
const script = {}
script.render = render

export default script